import content from "@/content/portfolio.json";

import { LiteYoutubeEmbed } from "react-lite-yt-embed";

interface Data {
  section_title: string;
  section_subtitle: string;
  videos: {
    title: string;
    youtube_url: string;
  }[];
}

const data: Data = content;

const Portfólio = () => {
  return (
    <section
      id="Portfólio"
      className="border-border bg-secondary/30 border-y py-20 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-display text-foreground text-4xl tracking-wide sm:text-5xl">
            {data.section_title}
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl">
            {data.section_subtitle}
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {data.videos.map((item, index) => (
            <div
              key={index}
              className="border-border bg-card hover:border-primary/50 overflow-hidden rounded-2xl border transition-all"
            >
              <div className="bg-secondary aspect-video w-full">
                <LiteYoutubeEmbed
                  id={item.youtube_url}
                  mute={false}
                  noCookie={true}
                  lazyImage={true}
                />
              </div>
              <div className="p-4">
                <p className="text-foreground font-medium">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfólio;
